import _classCallCheck from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var OptionsReader = /*#__PURE__*/function () {
  _createClass(OptionsReader, [{
    key: "window",
    get: function get() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== 'undefined') {
        return window;
      }
      return undefined;
    }
  }, {
    key: "document",
    get: function get() {
      var ref;
      if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) {
        return this.globalContext.document;
      } else if (this.window) {
        return this.window.document;
      } else {
        return undefined;
      }
    }
  }, {
    key: "rootElement",
    get: function get() {
      var ref;
      return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
  }]);
  function OptionsReader(globalContext, options) {
    _classCallCheck(this, OptionsReader);
    this.ownerDocument = null;
    this.globalContext = globalContext;
    this.optionsArgs = options;
  }
  return OptionsReader;
}();